export default "__VITE_ASSET__BBScrOuq__"